'use strict';

/* global $ */


import { interfaceName } from './settings';

import { AjaxForm } from './modules/ajax-form';
import { Goal } from './modules/goal';
import { Responsive } from './modules/responsive';
//import { Header } from './modules/header';
import { Slider } from './modules/slider';
import { Menu } from './modules/menu';
import { Tabs } from './modules/tabs';
import { Collapse } from './modules/collapse';
import { Calculator } from './modules/calculator';
import { Vote } from './modules/vote';
//import { Popup } from './modules/popup';
//import { Basket } from './modules/basket';
//import { Map } from './modules/map';
//import { CircleMenu } from './modules/circlemenu';
//import { ProductsMore } from './modules/products';
//import { Like } from './modules/like';
//import { Filters } from './modules/filters';

class Proj {
    constructor() {
        this.init();
    }
    init() {
        this.interfaceName = interfaceName;
        console.log('[ interfaceName ]', this.interfaceName);

        this.ajaxForm = new AjaxForm();
        this.goal = new Goal({
            goals: [
                {
                    selector: '.js-goal__link',
                    event: 'click',
                    handler: function() {
                        $(window).trigger('main:reachGoal', $(this).data());
                    }
                }, {
                    selector: '.js-goal__form',
                    event: 'submit',
                    handler: function() {
                        $(window).trigger('main:reachGoal', $(this).data());
                    }
                }, {
                    selector: window,
                    event: 'goal ajaxForm:goal',
                    handler: function(e, data) {
                        $(window).trigger('main:reachGoal', data);
                    }
                }
            ]
        });

        $('[data-fancybox]').fancybox({
            thumbs : {
                autoStart : false,
                axis: 'x'
            },
            transitionEffect: 'zoom-in-out',
            slideShow: {
                autoStart: false,
                speed: 2000,
            },
            loop: true,
            backFocus: false,
            lang: 'ru',
            i18n: {
                ru: {
                    CLOSE: 'Закрыть',
                    NEXT: 'Следующий',
                    PREV: 'Предыдущий',
                    ERROR: "Запрашиваемый контент не может быть загружен.<br/>Попробуйте позже.",
                    PLAY_START: 'Запустить слайдшоу',
                    PLAY_STOP: 'Остановить слайдшоу',
                    FULL_SCREEN: 'На весь экран',
                    THUMBS: 'Галерея превью',
                    DOWNLOAD: 'Скачать',
                    SHARE: 'Поделиться',
                    ZOOM: 'Увеличить'
                },
            },
            video: {
                tpl:
                  '<video class="fancybox-video" loop muted autoplay controlsList="nodownload" poster="{{poster}}">' +
                  '<source src="{{src}}" type="{{format}}" />' +
                  'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
                  "</video>",
                format: "",
                autoStart: true
            },
        });

        this.responsive = new Responsive();
        this.menu = new Menu({selector: '.js-menu'});
        this.tabs = new Tabs({selector: '.js-tabs'});
        this.collapse = new Collapse({selector: '.js-collapse'});
        this.voting = new Vote({selector: '.js-voting'});
        //this.popup = new Popup();
        
        if (this.interfaceName == 'home_page') {
            this.initPromoSlider();
        }

        this.calculator = new Calculator({selector: '.js-calculator'});

        $('.js-ajax-form__field select').select2({
            placeholder: 'выберите значения',
            minimumResultsForSearch: Infinity,
            width: 'element'
        });
        $('.js-ajax-form__field select').on('select2:opening select2:closing', function( event ) {
            //if ($(this).attr('name') == 'specialists') return;
            let $searchfield = $(this).parent().find('.select2-search__field');
            $searchfield.prop('disabled', true);
        });

        $('.js-password-control').on('click', function(e) {
            e.preventDefault();
            if ($(this).prev('input').attr('type') == 'password') {
                $(this).addClass('is-view');
                $(this).prev('input').attr('type', 'text');
            } else {
                $(this).removeClass('is-view');
                $(this).prev('input').attr('type', 'password');
            }
        });

        if ($('.js-calendar').length) {
            let events = [];
            $('.js-calendar__event').each(function() {
                let data = $(this).data();
                events.push({
                    startDate:  new Date(data.date),
                    endDate: new Date(data.date),
                    summary: `<a href="${data.href}">${data.name}</a>`
                })
            });
            console.log(events);
            $('.js-calendar').simpleCalendar({
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                fixedStartDay: true,
                disableEmptyDetails: true,
                events: events
            });
        }
    }


    initPromoSlider() {
        console.log('[ PromoSlider/Init ]');
        this.PromoSlider = new Slider({
            selector: '.js-promo__slider',
            show: 1,
            scroll: 1,
            arrows: false,
            dots: true,
            fade: true,
            speed: 1000,
            autoplay: true,
            autoplayspeed: 2000,
            infinite: true,
            drag: true,
            //slide: 'slider__item',
            //prev: '.js-promo__prev',
            //next: '.js-promo__next',
            rows: 0,
            perrorw: 1,
            adaptiveheight: false,
            //init: function(event, slick) {
            //},
            //before: function(event, slick, currentSlide, nextSlide) {
            //},
            //after: function(slick, currentSlide) {
            //},
        });
    }
}

$(function() {
    window.proj = new Proj();
});
